export const LBS_PER_TON = 2000;

export type Unit = 'lbs' | 'tons';

export function displayToLbs(value: number, unit: Unit): number {
  return unit === 'tons' ? value * LBS_PER_TON : value;
}

export function lbsToDisplayNumber(lbs: number, unit: Unit): number {
  return unit === 'tons' ? lbs / LBS_PER_TON : lbs;
}

/** Quoted/display weight — always carries thousands separators; tons always show two decimals. */
export function formatWeight(lbs: number, unit: Unit): string {
  if (unit === 'tons') {
    return (lbs / LBS_PER_TON).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  return Math.round(lbs).toLocaleString('en-US');
}

export function formatWeightValue(lbs: number | null | undefined, unit: Unit): string {
  if (lbs == null) return '';
  return formatWeight(lbs, unit);
}
